'use client';

import React, { createContext, useContext } from 'react';

const TranslationContext = createContext({
  t: (key: string) => key,
  locale: '',
});

export const TranslationProvider = ({
  children,
  initialDict,
  locale,
}: {
  children: React.ReactNode;
  initialDict: Record<string, string>;
  locale: string;
}) => {
  const t = (key: string) => initialDict[key] || key;

  return (
    <TranslationContext.Provider value={{ t, locale }}>
      {children}
    </TranslationContext.Provider>
  );
};

export const useTranslation = () => useContext(TranslationContext);
